<template>
<div>
  <modal-cadastro-assinatura ref="modalCadastroAssinatura"
                            :planos="planos"
                            :ufs="ufs"
                            @boletoGerado="buscarAssinaturas" />
  <modal-editar-assinatura ref="modalEditarAssinatura"
                            :assinatura-edicao="assinaturaEdicao"
                            :assinatura-mundipagg="assinaturaMundipagg"
                            :tipos_status="tipos_status"
                            :tipos_assinaturas="tipos_assinaturas"
                            @assinaturaAlterada="buscarAssinaturas"
                            @close="buscarAssinaturas" />

  <div class="tab-pane fade show active" id="pills-assinaturas" role="tabpanel" aria-labelledby="pills-assinaturas-tab">
      <div>
        <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="modalCadastrarAssinaturaBoleto()"><i class="fas fa-plus"></i> Criar assinatura por boleto</a>&#32;
         <b-link v-b-toggle.collapse-filter class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
      </div>
    </div>

  <b-collapse id="collapse-filter" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarAssinaturas">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label for="nome">Buscar</label>
                    <input type="text" class="form-control" id="nome" placeholder="Busque por nome / e-mail / telefone / faculdade" v-model="filtro.busca" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Plano</label>
                    <select class="form-control" v-model="filtro.plano_macro_id">
                      <option value="">Todos</option>
                      <option v-for="plano in planos" :value="plano.id" v-bind:key="plano.id">{{plano.nome}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Recorrencia</label>
                    <select class="form-control" v-model="filtro.duracao_id">
                      <option value="">Todos</option>
                      <option v-for="duracao in duracoes" :value="duracao.id" v-bind:key="duracao.id">{{duracao.nome}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Status da Assinatura</label>
                    <select class="form-control" v-model="filtro.status_assinatura_id">
                      <option value="">Todos</option>
                      <option v-for="tipo in tipos_status" :value="tipo.id" v-bind:key="tipo.id">{{tipo.descricao}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Gateway</label>
                    <select class="form-control" v-model="filtro.gateway_id">
                      <option value="">Todos</option>
                      <option v-for="tipo in tipos_gateways" :value="tipo.id" v-bind:key="tipo.id">{{tipo.nome}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Responsável</label>
                    <select class="form-control" v-model="filtro.criado_por">
                      <option value="">Todos</option>
                      <option v-for="responsavel in tipos_responsaveis" :value="responsavel.id" v-bind:key="responsavel.id">{{responsavel.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label>Tipo da Assinatura</label>
                    <select class="form-control" v-model="filtro.tipo_assinatura_id">
                      <option value="">Todos</option>
                      <option v-for="tipo in tipos_assinaturas" :value="tipo.id" v-bind:key="tipo.id">{{tipo.descricao}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data de criação</label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.validDate"/> Filtrar por data de validade</label>
                    <date-range-picker
                      v-if="filtro.validDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.validDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
              <br><br>
              <small class="ml-3"><a href="javascript:void(0)" @click="limparFiltro">Limpar filtro</a></small>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="assinaturas.length">
      <table class="table" ref="resultadoTabelaAssinaturas">
        <thead>
          <tr>
            <th>E-mail</th>
            <th>Plano</th>
            <th>Status</th>
            <th>Tipo</th>
            <th>Gateway</th>
            <th>Validade</th>
            <th>Criado em</th>
            <th>Responsável</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="assinatura in assinaturas" :key="assinatura.id">
            <td>{{ assinatura.user.email}}</td>
            <td>{{ assinatura.plano.plano }}</td>
            <td>{{ assinatura.status.descricao }}</td>
            <td>{{ assinatura.tipo.descricao }}</td>
            <td>{{ assinatura.gateway ? assinatura.gateway.nome : '' }}</td>
            <td>{{ assinatura.data_cancelamento | formatDate }}</td>
            <td>{{ assinatura.created_at | formatDate }}</td>
            <td>{{ assinatura.criado_por ? assinatura.criado_por.name : ''}}</td>
            <td>
              <div class="d-flex align-items-center">
                <a v-if="assinatura.status.descricao != 'Cancelado'" href="javascript:void(0)" v-b-tooltip.hover title="Editar Assinatura" @click="modalEditarAssinatura(assinatura)"><i class="fas fa-edit"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
</div>
</template>

<script>
import moment from 'moment'
import CortesiaAPI from '@/api/cortesia-api'
import AssinaturaAPI from '@/api/assinatura-api'
import EnderecoAPI from '@/api/endereco-api'
import DateUtils from '@/core/util/date-utils'
import InfiniteLoading from 'vue-infinite-loading'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import ModalCadastroAssinatura from '@/modules/Assinaturas/components/ModalCadastroAssinatura'
import ModalEditarAssinatura from '@/modules/Assinaturas/components/ModalEditarAssinatura'

export default {
  name: 'ListaAssinaturas',
  components: { DateRangePicker, InfiniteLoading, ModalCadastroAssinatura, ModalEditarAssinatura },
  data () {
    return {
      pagina: 1,
      planos: [],
      quantidade: 0,
      assinaturas: [],
      assinaturaEdicao: null,
      assinaturaMundipagg: null,
      infiniteId: new Date(),
      scrolled: false,
      tipos_planos: [],
      duracoes: [
        { 'id': 1, 'nome': 'Mensal' },
        { 'id': 3, 'nome': 'Trimestral' },
        { 'id': 6, 'nome': 'Semestral' },
        { 'id': 12, 'nome': 'Anual' }
      ],
      tipos_status: [],
      tipos_gateways: [],
      tipos_responsaveis: [],
      tipos_assinaturas: [],
      ufs: [],
      filtro: {
        plano_macro_id: '',
        duracao_id: '',
        tipo_pagamento_id: null,
        status_assinatura_id: null,
        gateway_id: '',
        criado_por: '',
        responsavel_id: '',
        tipo_assinatura_id: null,
        validade: false,
        data_validade: '',
        createdDate: false,
        validDate: false,
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        },
        validDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(DateUtils.create().add(1, 'month').toDate())
        }
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  mounted () {
    CortesiaAPI.listarPlanos().then(data => {
      this.planos = data
    })

    AssinaturaAPI.listarStatus().then(data => {
      this.tipos_status = data
    })

    AssinaturaAPI.listarGateway().then(data => {
      this.tipos_gateways = data
    })

    AssinaturaAPI.listarResponsavel().then(data => {
      this.tipos_responsaveis = data
    })

    AssinaturaAPI.listarTipos().then(data => {
      this.tipos_assinaturas = data
    })

    EnderecoAPI.listarUFs().then(data => {
      this.ufs = data
    })
  },

  methods: {

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    modalCadastrarAssinaturaBoleto: function () {
      this.$nextTick(() => {
        this.$refs.modalCadastroAssinatura.show()
      })
    },

    modalEditarAssinatura: function (assinatura) {
      this.assinaturaEdicao = Object.assign({}, assinatura)

      this.$nextTick(() => {
        this.assinaturaMundipagg = null
        this.$refs.modalEditarAssinatura.show()
      })
    },

    buscarAssinaturas: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.assinaturas = []
    },

    limparFiltro: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },

    infiniteHandler: function ($state) {
      AssinaturaAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.assinaturas.push(...data.data.map(item => {
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    }
  }
}
</script>

<style>
  h2 {
    border-left: 0px!important;
  }

  strong {
    font-weight: bold!important;
  }
</style>
